import { render, staticRenderFns } from "./DashboardGestor.vue?vue&type=template&id=75c6da92&scoped=true&"
import script from "./DashboardGestor.vue?vue&type=script&lang=js&"
export * from "./DashboardGestor.vue?vue&type=script&lang=js&"
import style0 from "./DashboardGestor.vue?vue&type=style&index=0&id=75c6da92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c6da92",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardText,VContainer,VDataTable})
